import { createContext, useContext } from 'react';

const NO_LABELS: ReadonlyMap<string, string> = new Map();

/**
 * Source id to friendly name, for the pills inside a {@link TokenInput}.
 *
 * Context rather than a node attribute because a pill is rebuilt from the saved
 * `{{ref}}` on every load, and a ref carries the source's stable id and nothing
 * else. The names live with the editor's upstream sources, which node views
 * cannot reach any other way — they render through portals owned by tiptap, so
 * a prop cannot be threaded to them, but React context still reaches them.
 */
export const TokenSourceLabelsContext =
  createContext<ReadonlyMap<string, string>>(NO_LABELS);

/** The names in scope for the editor this pill belongs to. */
export const useTokenSourceLabels = (): ReadonlyMap<string, string> =>
  useContext(TokenSourceLabelsContext);
